import styled from "styled-components";

export const ObjectLinkContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  position: relative;
`;
